"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledDrawerIconButton = exports.StyledDrawerHeading = exports.StyledDrawerHeader = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _buttons = require("../../fuse-buttons/src/buttons");
var _grid = require("../../fuse-responsive-grid/src/grid");
var _typography = require("../../fuse-typography/src/typography");
var _typographyConfig = require("../../fuse-typography/src/typography-config");
var _typography2 = require("../../fuse-typography-element/src/typography");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var StyledDrawerHeader = exports.StyledDrawerHeader = _styledComponents["default"].div.attrs({
  className: 'fuse-drawer__header'
}).withConfig({
  displayName: "styled-drawer-header__StyledDrawerHeader",
  componentId: "sc-ms79hl-0"
})(["align-items:center;background-color:var(--color-functional-panelLight);border-bottom:1px solid var(--color-global-grey400);color:var(--color-global-black);display:flex;left:0;padding:", ";position:sticky;right:0;top:0;transition:box-shadow 50ms ease-in-out;", " @media only screen and (min-width:", "){padding:", ";", "}"], _grid.gridConfig.xxs.margin, function (_ref) {
  var hasDepth = _ref.hasDepth;
  return hasDepth && (0, _styledComponents.css)(["box-shadow:var(--elevation-shadow-l);z-index:1;"]);
}, _grid.gridConfig.m.minWidth, _grid.gridConfig.m.margin, function (_ref2) {
  var hasDepth = _ref2.hasDepth;
  return hasDepth && (0, _styledComponents.css)(["box-shadow:var(--elevation-shadow-xl);z-index:1;"]);
});
var StyledDrawerIconButton = exports.StyledDrawerIconButton = (0, _styledComponents["default"])(_buttons.PlainIconButton).withConfig({
  displayName: "styled-drawer-header__StyledDrawerIconButton",
  componentId: "sc-ms79hl-1"
})(["", ""], function () {
  var _defaultCssProps$t, _iconButtonSizeConfig;
  var modalHeadingHeight = (0, _typography.convertRemToPx)(_typographyConfig.defaultCssProps === null || _typographyConfig.defaultCssProps === void 0 || (_defaultCssProps$t = _typographyConfig.defaultCssProps.t3) === null || _defaultCssProps$t === void 0 ? void 0 : _defaultCssProps$t.lineHeight);
  var buttonHeight = (_iconButtonSizeConfig = _buttons.iconButtonSizeConfig.small) === null || _iconButtonSizeConfig === void 0 || (_iconButtonSizeConfig = _iconButtonSizeConfig.iconHeight) === null || _iconButtonSizeConfig === void 0 ? void 0 : _iconButtonSizeConfig.replace('px', '');
  var buttonMarginTop = "".concat((modalHeadingHeight - buttonHeight) / 2, "px");
  return (0, _styledComponents.css)(["margin-top:", ";"], buttonMarginTop);
});
var StyledDrawerHeading = exports.StyledDrawerHeading = (0, _styledComponents["default"])(_typography2.TypographyComponent).attrs({
  className: 'fuse-drawer__heading'
}).withConfig({
  displayName: "styled-drawer-header__StyledDrawerHeading",
  componentId: "sc-ms79hl-2"
})(["", ""], function (_ref3) {
  var hasBackButton = _ref3.hasBackButton,
    hasIcon = _ref3.hasIcon;
  return "\n\t\tflex: 1 1 auto;\n\t\t".concat(hasBackButton || hasIcon ? "margin-left: var(--spacing-global-space3);" : "", "\n\t");
});